<template>
  <header class="usc-page-header">
    <a
      class="usc-page-header--hamburger"
      role="button"
      v-bind:aria-expanded="isMenuExpanded.toString()"
      aria-label="Menu"
      tabindex="0"
      @click="toggleMenu"
      @keypress="toggleMenu"
    >
      <v-icon large dark :class="{hidden: hidemenubutton}">menu</v-icon>
    </a>
    <router-link to="/" aria-label="USC Marshall School of Business - Home" title="Go to Home" tabindex="0">
      <div class="usc-page-header--uscm-logo">
        <img src="../assets/usc_marshall_logo_mobile_nav.svg" alt="USC Marshall School of Business logo - Home" title="Go to Home page">
        <span class="uscm-logotext">USC Marshall School of Business</span>
      </div>
    </router-link>
    <div class="usc-page-header--title">
      <span class="usc-page-header--section" v-if="$root.pageHeader.section">{{$root.pageHeader.section}}</span>
      <span class="usc-page-header--page" v-if="$root.pageHeader.title"> - {{$root.pageHeader.title}}</span>
    </div>
    <div class="usc-page-header--usc-logo">
      <a href="https://www.usc.edu/" target="_blank"><img src="../assets/usc_mobile_badge.svg" alt="USC logo"></a>
    </div>
  </header>
</template>

<script>
export default {
  name: 'PageHeader',
  props: ['section', 'page', 'hidemenubutton', 'isMenuExpanded'],
  data () {
    return {
      internalMenuExpanded: this.isMenuExpanded
    }
  },
  watch: {
    isMenuExpanded (newVal) {
      this.internalMenuExpanded = newVal
    }
  },
  methods: {
    toggleMenu () {
      this.internalMenuExpanded = !this.internalMenuExpanded
      this.$emit('menuclicked')
    }
  }
}
</script>

<style lang="scss">
@import '~styles/vars';

.usc-page-header {
  background: url(../assets/sidebar_pattern.jpg);
  width: 100%;
  flex-direction: row;
  display: flex;
  justify-content: space-between;
  position: fixed;
  top: 0;
  z-index: 5;
  align-items: center;
  height: 56px;
  padding-left: 20px;
  @media(min-width: $screen-md-min) {
    background: #fff;
    position: inherit;
    padding-right: 20px;
    z-index: 0;
  }
  &--hamburger {
    @media(min-width: $screen-md-min) {
      display: none;
    }
    > .icon {
      color: #fff;
      opacity: .3;
      transition: .3s opacity;
      cursor: pointer;
      &:hover {
        opacity: 1;
      }
      &.hidden {
        opacity: 0;
        pointer-events: none;
      }
    }
    display: flex;
    height: 100%;
    padding-right: 10px;
  }
  &--uscm-logo {
    height: 100%;
    @media(min-width: $screen-md-min) {
      display: none;
    }
    width: 98px;
    position: relative;
    > img {
      position: absolute;
      top: 50%;
      transform: translate(0,-50%);
    }
  }
  &--title {
    display: none;
    @media(min-width: $screen-sm-min) {
      display: flex;
      padding-right: 20px;
    }
    @media(min-width: $screen-md-min) {
      display: none;
    }
    height: 100%;
    align-items: center;
    flex: 1;
    white-space: nowrap;
    text-overflow: ellipsis;
    overflow: hidden;
    margin-left: 25px;
    padding-left: 25px;
    border-left: 1px solid rgba(255,255,255,.08);

    > .usc-page-header--section {
      color: #fff;
      text-transform: uppercase;
    }
    > .usc-page-header--page {
      color: $cYellow;
      margin-left: .5rem;
      overflow: hidden;
      text-overflow: ellipsis;
    }
  }
  &--usc-logo {
    display: flex;
    height: 100%;
    background: #fff;
    padding: 17px 10px;
    > a {
      display: block;
      width: 102px;
      img {
        float: right;
        height: 100%;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/PageHeader.vue